/**
 * ★ WA — COR por SDR no cartão do lead. Puro.
 *
 * A cor sai do `uid`, não da ordem da lista: derivar da posição faria a cor de todo mundo mudar quando
 * alguém entra na equipe — e a cor só serve para reconhecer a pessoa de relance.
 * Lead sem `sdrId` (inclusive o que só tem o nome em texto da planilha, `nomeSdrDaPlanilha`) fica NEUTRO:
 * cor é identidade de pessoa cadastrada, não de texto.
 *
 * Os pares foram escolhidos com fundo claro e texto escuro da mesma família (contraste ≥ 4.5 sobre o fundo
 * branco do cartão) e funcionam nos dois temas, porque são cores fixas — não tokens que invertem.
 */
export const PALETA = Object.freeze([
  Object.freeze({ fundo: '#dbeafe', texto: '#1e40af' }), // azul
  Object.freeze({ fundo: '#dcfce7', texto: '#166534' }), // verde
  Object.freeze({ fundo: '#fef3c7', texto: '#92400e' }), // âmbar
  Object.freeze({ fundo: '#fce7f3', texto: '#9d174d' }), // rosa
  Object.freeze({ fundo: '#e0e7ff', texto: '#3730a3' }), // índigo
  Object.freeze({ fundo: '#ccfbf1', texto: '#115e59' }), // teal
  Object.freeze({ fundo: '#ffedd5', texto: '#9a3412' }), // laranja
  Object.freeze({ fundo: '#ede9fe', texto: '#5b21b6' }), // violeta
]);

/** Sem SDR cadastrado: o cinza de sempre. */
export const NEUTRA = Object.freeze({ fundo: 'transparent', texto: 'var(--cor-texto-suave)' });

/** Hash estável (djb2) do uid → índice na paleta. */
export function corDoSdr(sdrId) {
  const id = typeof sdrId === 'string' ? sdrId.trim() : '';
  if (!id) return NEUTRA;
  let h = 5381;
  for (let i = 0; i < id.length; i++) h = ((h * 33) ^ id.charCodeAt(i)) >>> 0;
  return PALETA[h % PALETA.length];
}
